<div class="cart-item">

  <div class="image-wrapper">

    <image *ngIf="product.previewPhoto; else elseBlock"
           [imageLink]="product.previewPhoto"
           (click)="openProductInfo()"></image>
  </div>
  <ng-template #elseBlock>
    <div class="image-not-found">

      <img *ngIf="!product.imageLink" src="../../../assets/not_found.png" class="image-not-found" (click)="openProductInfo()"/>
      <img  *ngIf="product.imageLink" src="{{product.imageLink}}" class="image-not-found" (click)="openProductInfo()"/>
    </div>
  </ng-template>

  <div class="product-info">
    <div>
      <div class="product-name">{{product.name}}</div>
      <div class="author">{{product.author}}</div>
    </div>



    <div class="count-block">

      <div class="buttons-block">
        <button class="decrease" [disabled]="count < 2" (click)="decreaseCount()">-</button>

        <input type="number" class="count-area"
               [ngModel]="count"
               [disabled]=true
               (ngModelChange)="changeCount($event)">

        <button class="increase" [disabled]="count >= product.countInStock && product.availability.status =='in_stock'"
                (click)="increaseCount()">+
        </button>

      </div>

    </div>


  </div>
  <div class="right-panel">
    <div class="cost-info">
      <div *ngIf="product.discount"
           class="discount"> {{productService.roundPriceStr(product.retailPriceEuro * count)  | number : '1.2-2' | currency: "EUR"}}</div>
      {{productService.roundPriceStr(product.discountPriceEuro * count)  | number : '1.2-2' | currency: "EUR"}}
    </div>
    <button class="menu-button-cart" (click)="deleteAll()">
      <span class="icon-trash_">
        <img src="../../../../assets/icons/trash.svg" class="icon-menu">
      </span>
    </button>
  </div>
</div>

<ng-template #dialog class="delete-dialog">
  <h2 mat-dialog-title>Удалить товар из корзины?</h2>
  <div mat-dialog-actions>
    <button class="main-button  cancel" mat-button [mat-dialog-close]="true">Да</button>
    <button class="main-button" mat-button mat-dialog-close [mat-dialog-close]="false">Нет</button>
  </div>
</ng-template>

